
export const phoneCleanForSet = value => {
    let phone = ''

    let phoneItems = value.match(/[0-9]+/g)
    if (phoneItems === null) {
        return ''
    }
    phoneItems.forEach(function (i) {
        phone += i;
    })
    return phone;
}

export const phoneClean = value =>{
    if (value === undefined){
        return ''
    }
    let phone = ''
    let phoneItems = value.match(/[0-9]+/g)
    if (phoneItems === null) {
    return ''
    }
    phoneItems.forEach(function(i) {
    phone += i;
    })
    return phone
}